import { render, staticRenderFns } from "./UmbFooterInvestment.vue?vue&type=template&id=d8744d78&scoped=true"
import script from "./UmbFooterInvestment.vue?vue&type=script&lang=ts"
export * from "./UmbFooterInvestment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8744d78",
  null
  
)

export default component.exports